import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setErrorMsg("");
      setLoading(true);
      if (!passwordRef.current?.value || !emailRef.current?.value) {
        setErrorMsg("Please fill in the fields");
        return;
      }
      const {
        data: { user, session },
        error,
      } = await login(emailRef.current.value, passwordRef.current.value);
      if (error) setErrorMsg(error.message);
      if (user && session) navigate("/absences");
    } catch (error) {
      setErrorMsg("Email or Password Incorrect");
    }
    setLoading(false);
  }

  return (
    <>
      <div className="card">
        <h2>Login to your account</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="input-email">Email</label>
            <input id="input-email" type="email" ref={emailRef} required />
          </div>
          <div className="form-group">
            <label htmlFor="input-password">Password</label>
            <input
              id="input-password"
              type="password"
              ref={passwordRef}
              required
            />
          </div>
          {errorMsg && (
            <div className="alert alert-danger" role="alert">
              {errorMsg}
            </div>
          )}
          <div className="text-center mt-2">
            <button disabled={false} type="submit" className="cstm-button">
              Login
            </button>
          </div>
        </form>
      </div>
      <div className="w-100 text-center mt-2">
        Don't have an account? <Link to="/register">Sign Up</Link>
      </div>
      <div className="w-100 text-center mt-2">
        Forgot Password? <Link to={"/reset-password"}>Click Here</Link>
      </div>
    </>
  );
}
